import { render, staticRenderFns } from "./ChangePasswordComponent.vue?vue&type=template&id=ebcfdcd4&scoped=true"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordComponent.vue?vue&type=style&index=0&id=ebcfdcd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcfdcd4",
  null
  
)

export default component.exports